<div class="container">
  <div class="tabs">
    @for (tab of tabs(); track $index) {
      <a
        role="tab"
        class="tabs-tab"
        [class.is-active]="tab.selected"
        [attr.data-testid]="'sidebar-tab-' + tab.name"
        (click)="switchTab(tab)">
        <ui-inline-svg class="tabs-tab-icon" [name]="tab.icon"></ui-inline-svg>
        <span class="tabs-tab-text">
          {{ tab.name | transloco }}
        </span>
      </a>
    }
  </div>

  <button class="toggle" data-testid="sidebar-toggle" type="button" (click)="onShowHideTabs()">
    <ui-inline-svg [name]="'sidebar-left-' + (openTabs() ? 'open' : 'close')"></ui-inline-svg>
  </button>
</div>
